import { CIcon } from '~/icons/types'

export const ciBoatTourist: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M23.793 12.1a.5.5 0 0 0-.418-.225H19.18V9.356a1.755 1.755 0 0 0-1.752-1.752h-2.62V6.04c0-.622-.29-1.04-.72-1.04h-2.3c-.432 0-.72.418-.72 1.04v1.564h-6.8a1.754 1.754 0 0 0-1.754 1.752v5.082H.504a.5.5 0 0 0-.465.692l1.86 4.462a.5.5 0 0 0 .461.307h17.008c1.15 0 1.986-1.551 2.384-2.476l2.087-4.851a.499.499 0 0 0-.046-.472ZM12.071 6.04V6h1.735v1.604h-1.735V6.04ZM3.514 9.356a.752.752 0 0 1 .752-.752h13.162a.752.752 0 0 1 .752.752v2.519h-1.278v-1.731a.5.5 0 0 0-.5-.5h-2.23a.5.5 0 0 0-.5.5v2.231a.5.5 0 0 0 .5.5h1.4l-1.6 1.563H3.513V9.356Zm12.388 1.288v1.231h-1.23v-1.231h1.23Zm4.937 6.384c-.459 1.067-1.089 1.871-1.466 1.871H2.695l-1.442-3.461h12.918a.5.5 0 0 0 .35-.143l2.48-2.42h5.615l-1.777 4.153Z'
    },
    {
      d:
        'M7.477 9.645H5.246a.5.5 0 0 0-.5.5v2.23a.5.5 0 0 0 .5.5h2.23a.5.5 0 0 0 .5-.5v-2.23a.5.5 0 0 0-.5-.5Zm-.5 2.23H5.746v-1.23h1.23v1.23Zm4.963-2.23H9.709a.5.5 0 0 0-.5.5v2.23a.5.5 0 0 0 .5.5h2.23a.5.5 0 0 0 .5-.5v-2.23a.5.5 0 0 0-.5-.5Zm-.5 2.23h-1.231v-1.23h1.23v1.23Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'tourist',
  type: 'thin'
}
